<div class="container-fluid service-bg">
    <div class="row">
        <div class="col-md-12 from-top">
            <!-- Welcome Message -->
            <h1 class="text-center">{{'gen_reset_pwd' | translate}}</h1>

            <!-- Reset Passwword Form -->
            <div class="form-group login-form" [formGroup]="resetGroup">
                <mat-form-field class="form-element" appearance="fill">
                    <mat-label>{{'gen_password' | translate}}</mat-label>
                    <input [type]="hide ? 'password' : 'text'" matInput placeholder="{{'gen_password' | translate}}"
                        formControlName="password">
                    <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <!-- Errors -->
                    <mat-error *ngIf="resetGroup.controls.password.errors?.required">{{'error_required_error' |
                        translate}}</mat-error>
                    <mat-error *ngIf="resetGroup.controls.password.errors?.pattern">{{'error_password_regex' |
                        translate}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="form-element" appearance="fill">
                    <mat-label>{{'gen_confirm_password' | translate}}</mat-label>
                    <input [type]="hide2 ? 'password' : 'text'" matInput
                        placeholder="{{'gen_confirm_password' | translate}}" formControlName="confirmPassword">
                    <mat-icon matSuffix (click)="hide2 = !hide2">{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>

                    <!-- Errors -->
                    <mat-error *ngIf="resetGroup.controls.confirmPassword.errors?.required">{{'error_required_error' |
                        translate}}</mat-error>
                    <mat-error *ngIf="resetGroup.controls.confirmPassword.errors?.pattern">{{'error_password_regex' |
                        translate}}</mat-error>
                    <mat-error *ngIf="resetGroup.controls.confirmPassword.errors?.confirmedValidator">
                        {{'error_confirm_missmatch' | translate}}</mat-error>
                </mat-form-field>

                <button class="button w-100" (click)="resetPassword()" [disabled]="resetGroup.status == 'INVALID'">
                    <i class="pr-1 fa fa-sign-in-alt"></i>
                    {{'gen_reset_pwd' | translate}}
                </button>

                <!-- Go Back to Login -->
                <p class="text-right">
                    <a href="#/login">
                        {{'register_go_to_login' | translate}}
                    </a>
                </p>

            </div>
        </div>
    </div>
</div>